export { useResizingWidth, ResizingWidth } from '../resizing/width';
